import {
    apiRegister
} from '../../common/api';

import {
    isArray
} from '../../common/utils';

/*
协议Id 
41
项目 
模块 
方式 
https 
命令（路径） 
/oauth/bindlist/
说明
获取我的绑定列表
*/

const oauthBindList = apiRegister('oauthBindList', {
    protoId: 41,
    path: "/oauth/bindlist/",
    formatResult({
        bindList
    }) {
        bindList = isArray(bindList) ? bindList : []
        return {bindList};
    }
});

// 接口
export const oauthBindListLoad = oauthBindList.send;
